import {
    formatValue,
} from './format-value';

export function checkValue(value: string, minLength: number, maxLength: number): boolean {
    const formattedValue = formatValue(value);

    if (!formattedValue) {
        return false;
    }
    if (formattedValue.length < minLength) {
        return false;
    }
    if (formattedValue.length > maxLength) {
        return false;
    }

    return true;
}
